import { render, staticRenderFns } from "./WalletImport.vue?vue&type=template&id=47181f3e&scoped=true&"
import script from "./WalletImport.vue?vue&type=script&lang=js&"
export * from "./WalletImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47181f3e",
  null
  
)

export default component.exports